'use client';

import {
  useAuth,
  useNonStudentRedirect,
  useNotLoggedInRedirect,
} from '@/context/Authentication';
import { Parrot } from '@/components';
import { StudentPod } from '@/components/student';

const StudentHome = () => {
  const { user } = useAuth();

  useNonStudentRedirect();
  useNotLoggedInRedirect();

  return (
    user?.isStudent && (
      <div className="my-12 lg:mx-48 grid xl:grid-cols-2 gap-12">
        <StudentPod
          title="Your books"
          accessory={<Parrot className="max-h-[90%] w-auto" type="reading" />}
          alignAccessory="bottom"
          className="h-64"
          to="/reading"
        />

        <StudentPod
          title="Join a lesson"
          bgColor="yellow"
          alignAccessory="bottom"
          className="h-64"
          to="/join"
        />

        <StudentPod
          title="Homework"
          bgColor="orange"
          accessory={
            <Parrot className="max-h-[90%] w-auto ml-6" type="learning" />
          }
          alignAccessory="bottom"
          className="h-64"
          to="/homework"
        />

        <StudentPod
          title="Lessons"
          bgColor="red"
          accessory={
            <Parrot className="max-h-[90%] w-auto  ml-6" type="teacher" />
          }
          alignAccessory="bottom"
          className="h-64"
          to="/lessons"
        />
      </div>
    )
  );
};

export default StudentHome;
